import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Focusable, Group, Link, Pressable, Text, useContextProps } from "react-aria-components";
import { icon } from "../icon.css.js";
import { User01 } from "../icons/line.js";
import { abbreviateName } from "../utils/name.js";
import useTextFit from "../utils/useTextFit.js";
import { avatarImage, baseAvatarStyle, placeholderTextStyle } from "./Avatar.css.js";
import { Tooltip } from "./Tooltip.js";
import { AvatarContext } from "./shared/AvatarContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
const AutoTextFit = t0 => {
  const $ = _c(9);
  const {
    size,
    children
  } = t0;
  const {
    textRef,
    containerRef
  } = useTextFit(children, 6, 16, 10, 0.5);
  let t1;
  if ($[0] !== size) {
    t1 = placeholderTextStyle({
      size
    });
    $[0] = size;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== textRef) {
    t2 = /*#__PURE__*/_jsx("span", {
      ref: textRef,
      children: children
    });
    $[2] = children;
    $[3] = textRef;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== containerRef || $[6] !== t1 || $[7] !== t2) {
    t3 = /*#__PURE__*/_jsx(Text, {
      ref: containerRef,
      className: t1,
      children: t2
    });
    $[5] = containerRef;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
const defaultSize = "m";
const BaseAvatarImage = (t0, ref) => {
  const $ = _c(29);
  const {
    children,
    size: t1,
    isIcon: t2,
    insideInputBuilder: t3,
    tooltip,
    href,
    onPress,
    active,
    isInteractive,
    showBorder
  } = t0;
  const size = t1 === undefined ? defaultSize : t1;
  const isIcon = t2 === undefined ? false : t2;
  const insideInputBuilder = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== active || $[1] !== insideInputBuilder || $[2] !== isIcon || $[3] !== isInteractive || $[4] !== showBorder || $[5] !== size) {
    t4 = baseAvatarStyle({
      size,
      isIcon,
      isInteractive,
      active,
      insideInputBuilder,
      showBorder
    });
    $[0] = active;
    $[1] = insideInputBuilder;
    $[2] = isIcon;
    $[3] = isInteractive;
    $[4] = showBorder;
    $[5] = size;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const className = t4;
  if (href != null) {
    const t5 = ref;
    let t6;
    if ($[7] !== children || $[8] !== className || $[9] !== href || $[10] !== onPress || $[11] !== t5) {
      t6 = /*#__PURE__*/_jsx(Link, {
        ref: t5,
        onPress: onPress,
        href: href,
        className: className,
        children: children
      });
      $[7] = children;
      $[8] = className;
      $[9] = href;
      $[10] = onPress;
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  if (!tooltip && onPress == null) {
    let t5;
    if ($[13] !== children || $[14] !== className) {
      t5 = /*#__PURE__*/_jsx("div", {
        className: className,
        children: children
      });
      $[13] = children;
      $[14] = className;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    return t5;
  }
  if (onPress == null) {
    const t5 = ref;
    let t6;
    if ($[16] !== children || $[17] !== className) {
      t6 = /*#__PURE__*/_jsx("div", {
        role: "treeitem",
        className: className,
        children: children
      });
      $[16] = children;
      $[17] = className;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    let t7;
    if ($[19] !== t5 || $[20] !== t6) {
      t7 = /*#__PURE__*/_jsx(Focusable, {
        ref: t5,
        children: t6
      });
      $[19] = t5;
      $[20] = t6;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    return t7;
  }
  const t5 = ref;
  let t6;
  if ($[22] !== children || $[23] !== className) {
    t6 = /*#__PURE__*/_jsx("div", {
      role: "treeitem",
      className: className,
      children: children
    });
    $[22] = children;
    $[23] = className;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== onPress || $[26] !== t5 || $[27] !== t6) {
    t7 = /*#__PURE__*/_jsx(Pressable, {
      ref: t5,
      onPress: onPress,
      children: t6
    });
    $[25] = onPress;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
};
const AvatarImage = /*#__PURE__*/React.forwardRef(BaseAvatarImage);
const BaseAvatarTooltip = (t0, ref) => {
  const $ = _c(15);
  let children;
  let isIcon;
  let props;
  let t1;
  let tooltip;
  if ($[0] !== t0) {
    ({
      children,
      tooltip,
      name: t1,
      isIcon,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = isIcon;
    $[3] = props;
    $[4] = t1;
    $[5] = tooltip;
  } else {
    children = $[1];
    isIcon = $[2];
    props = $[3];
    t1 = $[4];
    tooltip = $[5];
  }
  const name = t1 === undefined ? "" : t1;
  const text = typeof tooltip === "string" ? tooltip : name;
  const hasTooltip = tooltip !== false && text.length > 0;
  let t2;
  if ($[6] !== children || $[7] !== hasTooltip || $[8] !== isIcon || $[9] !== props || $[10] !== ref) {
    t2 = /*#__PURE__*/_jsx(AvatarImage, {
      tooltip: hasTooltip,
      ...props,
      ref: ref,
      isIcon: isIcon,
      children: children
    });
    $[6] = children;
    $[7] = hasTooltip;
    $[8] = isIcon;
    $[9] = props;
    $[10] = ref;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const avatarImage = t2;
  if (!hasTooltip) {
    return avatarImage;
  }
  let t3;
  if ($[12] !== avatarImage || $[13] !== text) {
    t3 = /*#__PURE__*/_jsx(Tooltip, {
      text: text,
      children: avatarImage
    });
    $[12] = avatarImage;
    $[13] = text;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
const AvatarTooltip = /*#__PURE__*/React.forwardRef(BaseAvatarTooltip);

// `fetchPriority` is only supported as React prop in v19+, so we're doing lowercase: https://github.com/facebook/react/issues/28948#issuecomment-2082311583
const fetchPriorityProps = React.version.startsWith("18") ? {
  fetchpriority: "high"
} : {
  fetchPriority: "high"
};
const iconSizeMapping = {
  xxs: "s",
  xs: "s",
  s: "m",
  m: "l",
  l: "l",
  xl: "l",
  xxl: "l"
};
const BaseAvatar = (baseProps, baseRef) => {
  const $ = _c(29);
  const [combinedProps, ref] = useContextProps(baseProps, baseRef, AvatarContext);
  let alt;
  let isInteractive;
  let props;
  let size;
  let t0;
  if ($[0] !== combinedProps || $[1] !== ref) {
    t0 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        src,
        size: t1,
        alt: t2,
        icon: Icon,
        isInteractive: isInteractiveProp,
        ...t3
      } = combinedProps;
      alt = t2;
      props = t3;
      size = t1 === undefined ? defaultSize : t1;
      isInteractive = isInteractiveProp ?? (props.href != null || props.onPress != null);
      if (src != null) {
        let t4;
        if ($[7] !== alt || $[8] !== src) {
          t4 = /*#__PURE__*/_jsx("img", {
            className: avatarImage,
            src: src,
            alt: alt,
            ...fetchPriorityProps
          });
          $[7] = alt;
          $[8] = src;
          $[9] = t4;
        } else {
          t4 = $[9];
        }
        t0 = /*#__PURE__*/_jsx(AvatarTooltip, {
          ref: ref,
          ...props,
          size: size,
          isInteractive: isInteractive,
          children: t4
        });
        break bb0;
      }
      if (Icon != null) {
        const t4 = iconSizeMapping[size];
        let t5;
        if ($[10] !== t4) {
          t5 = icon({
            size: t4
          });
          $[10] = t4;
          $[11] = t5;
        } else {
          t5 = $[11];
        }
        let t6;
        if ($[12] !== Icon || $[13] !== alt || $[14] !== t5) {
          t6 = /*#__PURE__*/_jsx(Icon, {
            className: t5,
            "aria-label": alt
          });
          $[12] = Icon;
          $[13] = alt;
          $[14] = t5;
          $[15] = t6;
        } else {
          t6 = $[15];
        }
        t0 = /*#__PURE__*/_jsx(AvatarTooltip, {
          ref: ref,
          ...props,
          size: size,
          isInteractive: isInteractive,
          isIcon: true,
          children: t6
        });
        break bb0;
      }
      if (props.name != null) {
        let t4;
        if ($[16] !== size) {
          t4 = placeholderTextStyle({
            size
          });
          $[16] = size;
          $[17] = t4;
        } else {
          t4 = $[17];
        }
        t0 = /*#__PURE__*/_jsx(AvatarTooltip, {
          ref: ref,
          ...props,
          size: size,
          isInteractive: isInteractive,
          children: /*#__PURE__*/_jsx("div", {
            className: t4,
            "aria-label": alt,
            children: abbreviateName(props.name)
          })
        });
        break bb0;
      }
    }
    $[0] = combinedProps;
    $[1] = ref;
    $[2] = alt;
    $[3] = isInteractive;
    $[4] = props;
    $[5] = size;
    $[6] = t0;
  } else {
    alt = $[2];
    isInteractive = $[3];
    props = $[4];
    size = $[5];
    t0 = $[6];
  }
  if (t0 !== Symbol.for("react.early_return_sentinel")) {
    return t0;
  }
  const t1 = iconSizeMapping[size];
  let t2;
  if ($[18] !== t1) {
    t2 = icon({
      size: t1
    });
    $[18] = t1;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  let t3;
  if ($[20] !== alt || $[21] !== t2) {
    t3 = /*#__PURE__*/_jsx(User01, {
      className: t2,
      "aria-label": alt
    });
    $[20] = alt;
    $[21] = t2;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  let t4;
  if ($[23] !== isInteractive || $[24] !== props || $[25] !== ref || $[26] !== size || $[27] !== t3) {
    t4 = /*#__PURE__*/_jsx(AvatarImage, {
      ref: ref,
      ...props,
      size: size,
      isInteractive: isInteractive,
      isIcon: true,
      tooltip: false,
      children: t3
    });
    $[23] = isInteractive;
    $[24] = props;
    $[25] = ref;
    $[26] = size;
    $[27] = t3;
    $[28] = t4;
  } else {
    t4 = $[28];
  }
  return t4;
};
export const Avatar = /*#__PURE__*/React.forwardRef(BaseAvatar);
export const Counter = t0 => {
  const $ = _c(11);
  const {
    size,
    tooltip,
    count
  } = t0;
  let t1;
  if ($[0] !== size) {
    t1 = baseAvatarStyle({
      size
    });
    $[0] = size;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = count > 99 ? "99+" : `+${count}`;
  let t3;
  if ($[2] !== size || $[3] !== t2) {
    t3 = /*#__PURE__*/_jsx(AutoTextFit, {
      size: size,
      children: t2
    });
    $[2] = size;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = /*#__PURE__*/_jsx(Group, {
      className: t1,
      children: t3
    });
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const counter = t4;
  if (typeof tooltip === "string") {
    let t5;
    if ($[8] !== counter || $[9] !== tooltip) {
      t5 = /*#__PURE__*/_jsx(Tooltip, {
        text: tooltip,
        children: counter
      });
      $[8] = counter;
      $[9] = tooltip;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  return counter;
};
//# sourceMappingURL=Avatar.js.map